module.exports = __webpack_public_path__ + "static/media/result_nare_cup2023-2.0881253e.jpg";